export const BANK_DETAILS = {
  accountName: "Ayome Groceries",
  sortCode: "04-06-05",
  accountNumber: "28470085",
};

export const DELIVERY_ZONES = [
  { name: "Dorchester", charge: 0 },
  { name: "Weymouth", charge: 10 },
  { name: "Portland", charge: 10 },
  { name: "Bridport", charge: 10 },
  { name: "Yeovil", charge: 10 },
];

export const FIXED_CHARGE = 10.0;
export const SERVICE_RATE = 0.12;
export const SERVICE_THRESHOLD = 100.0;

export function serviceCharge(subtotal) {
  const s = Number(subtotal || 0);
  return s > SERVICE_THRESHOLD ? Math.round(s * SERVICE_RATE * 100) / 100 : FIXED_CHARGE;
}

export const ORDER_STATUSES = ["Order Received", "Preparing", "Processing", "Ready", "Delivered", "Cancelled"];

export const STOCK_STATUSES = [
  { value: "in_stock", label: "In Stock" },
  { value: "low_stock", label: "Low Stock" },
  { value: "out_of_stock", label: "Out of Stock" },
];

export const STOCK_BADGE = {
  low_stock: { label: "Low Stock", cls: "bg-[#FF9500] text-white" },
  out_of_stock: { label: "Out of Stock", cls: "bg-[#FF3B30] text-white" },
};

export const STATUS_STYLES = {
  "Order Received": "bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE]",
  Preparing: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]",
  Processing: "bg-[#FFEDD5] text-[#9A3412] border-[#FED7AA]",
  Ready: "bg-[#F3E8FF] text-[#6B21A8] border-[#E9D5FF]",
  Delivered: "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]",
  Cancelled: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]",
};

export const CATEGORY_IMAGES = {
  bakery: "https://images.unsplash.com/photo-1509440159596-0249088772ff?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  fish: "https://images.unsplash.com/photo-1634932515818-7f9292c4e149?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  grains: "https://images.unsplash.com/photo-1621956838481-f8f616950454?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  meat: "https://images.unsplash.com/photo-1602470521006-aaea8b2fcc36?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  noodles: "https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  poultry: "https://images.unsplash.com/photo-1587593810167-a84920ea0781?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  seasonings: "https://images.unsplash.com/photo-1506368249639-73a05d6f6488?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
  tubers: "https://images.pexels.com/photos/34143558/pexels-photo-34143558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  vegetables: "https://images.unsplash.com/photo-1687422809617-a7d97879b3b0?crop=entropy&cs=srgb&fm=jpg&q=80&w=400",
};

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1734255026082-82fdc81991f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function gbp(n) {
  return "£" + Number(n || 0).toFixed(2);
}
